import {gsap} from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {breakpointDown, breakpointUp, getScreenHeight} from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)


function changeHeroesHeight() {
  $('.block-heroes-stories .block-intro').height($('.block-heroes-stories .block-intro .block-content').prop('clientHeight'))
}

let heroesTl;
window.initHeroesStories = () => {
  const block = document.querySelector('.block-heroes-stories')
  if (!block) return false

  if (heroesTl) {
    ScrollTrigger.getById('heroesReveal').kill(true);
    heroesTl.kill(true);
    heroesTl = null;
  }

  const intro = document.querySelector('.block-intro')
  const reveal = block.querySelector('.block-intro-reveal')

  const blockContent = block.querySelector('.inner-content')
  const blockContentHeight = blockContent.clientHeight;
  const windowHeight = $(window).height();
  const blockIntroImage = $('.block-intro-image')



  heroesTl = gsap.timeline({
    scrollTrigger: {
      trigger: intro,
      id: 'heroesReveal',
      pin: true,
      start: 'top top',
      end: `+=200%`,
      scrub: true,
      // markers: true,
    },
  });

  heroesTl.add(gsap.fromTo(
    reveal,
    {height: 0,},
    {height: '100lvh',}
  ));

  heroesTl.add(gsap.to(".js--block-intro-image .first-block", {y: -80}), 0);
  heroesTl.add(gsap.to(".js--block-intro-image .second-block", {y: 80}), 0);

  heroesTl.to(blockContent, {y: -(blockContentHeight - windowHeight)});
  blockIntroImage.removeAttr("style")
  blockIntroImage.css('margin-bottom', $('.js--heroes-stories-text').height() + parseFloat(blockIntroImage.css('margin-top')) + 'px')
  if ($(window).width() < 992) {
    if (blockIntroImage.height() > ($(window).width() - 32)) {

      blockIntroImage.css('width', '100%')
      blockIntroImage.css('height', 'auto')
      blockIntroImage.css('aspect-ratio', '1')
      blockIntroImage.css('max-width', '100%')
    } else {
      blockIntroImage.css('width', blockIntroImage.height())
    }
  } else {
    blockIntroImage.css('width', '24rem')
  }

}

$(window).on("load", function() {
  initHeroesStories()
});
